module.exports = __webpack_public_path__ + "img/w3_maximize_light.8a886506.png";